import { QueryFilter } from "../Types/CommonTypes";

const stringFields = ["name", "ext_Email","ext_Name"];

export const buildQueryFilter = (property: string, value: string): QueryFilter => {
    const lower = property.toLowerCase();
    const operator = (stringFields.some((f) => lower.includes(f)) || lower.length === 0) ? "StartsWith" : "Equals";
  return { property, value, operator };
};

export default buildQueryFilter;
